import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ProductCard from '../components/ProductCard';
import './HomePage.css';
import BannerGrid from '../components/BannerGrid';
import FullWidthCarousel from '../components/FullWidthCarousel';


const banners = [
  { image: require('../assets/images/banners/photo1.jpg'), link: '#link10' }, 
  { image: require('../assets/images/banners/photo2.jpg'), link: '#link12' },
  { image: require('../assets/images/banners/photo3.jpg'), link: '#link1' },
  { image: require('../assets/images/banners/photo4.jpg'), link: '#link1' },
  { image: require('../assets/images/banners/photo5.jpg'), link: '#link2' },
  { image: require('../assets/images/banners/photo6.jpg'), link: '#link3' },
  { image: require('../assets/images/banners/photo7.jpg'), link: '#link4' },
  { image: require('../assets/images/banners/photo8.jpg'), link: '#link10' }, 


];

const carouselImages = [
  { src: require('../assets/images/carouselImages/photo1.jpg'), link: '#mini1' },
  { src: require('../assets/images/carouselImages/photo2.jpg'), link: '#mini2' },
  { src: require('../assets/images/carouselImages/photo3.jpg'), link: '#mini3' },
  { src: require('../assets/images/carouselImages/photo4.jpg'), link: '#mini4' },
  { src: require('../assets/images/carouselImages/photo5.jpg'), link: '#mini5' },
  { src: require('../assets/images/carouselImages/photo6.jpg'), link: '#mini6' },
  { src: require('../assets/images/carouselImages/photo7.jpg'), link: '#mini7' },
  { src: require('../assets/images/carouselImages/photo8.jpg'), link: '#mini8' },
  { src: require('../assets/images/carouselImages/photo9.jpg'), link: '#mini9' },
  { src: require('../assets/images/carouselImages/photo10.jpg'), link: '#mini9' },
  { src: require('../assets/images/carouselImages/photo11.jpg'), link: 'https://xb-kaluga.site/products/10' },
  { src: require('../assets/images/carouselImages/photo12.jpg'), link: 'https://xb-kaluga.site/products/11' },
  { src: require('../assets/images/carouselImages/photo13.jpg'), link: 'https://xb-kaluga.site/products/12' },
  { src: require('../assets/images/carouselImages/photo14.jpg'), link: 'https://xb-kaluga.site/products/14' },
  { src: require('../assets/images/carouselImages/photo15.jpg'), link: 'https://xb-kaluga.site/products/7' },
  { src: require('../assets/images/carouselImages/photo16.jpg'), link: 'https://xb-kaluga.site/products/13' },
  { src: require('../assets/images/carouselImages/photo17.jpg'), link: 'https://xb-kaluga.site/products/4' },
  { src: require('../assets/images/carouselImages/photo18.jpg'), link: 'https://xb-kaluga.site/products/5' },
  { src: require('../assets/images/carouselImages/photo19.jpg'), link: 'https://xb-kaluga.site/products/6' },
  { src: require('../assets/images/carouselImages/photo20.jpg'), link: 'https://xb-kaluga.site/products/3' },
  { src: require('../assets/images/carouselImages/photo21.jpg'), link: 'https://xb-kaluga.site/products/8' },
];   

const statusOrder = ['Премиум', 'Стандарт', 'Обычный'];

const HomePage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('/api/products');
        setProducts(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Ошибка загрузки продуктов:', err);
        setError('Не удалось загрузить товары. Пожалуйста, попробуйте позже.');
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <div className="home-page__loading">Загрузка товаров...</div>;
  }

  if (error) {
    return <div className="home-page__error">{error}</div>;
  }

  const filteredProducts = products.filter(
    (product) => product.isVisible && product.isVerified
  );

  const sortedProducts = filteredProducts.sort((a, b) => {
    const indexA = statusOrder.indexOf(a.status);
    const indexB = statusOrder.indexOf(b.status);
    return indexA - indexB;
  });

  return (
    <div className="home-page">
      <h1>Проститутки - Эскорт - Шлюхи - Индивидуалки в Калуга </h1>
      {/* Слайдер на всю ширину */}
      <div className="home-page__slider">
        <FullWidthCarousel images={carouselImages} />
      </div>

      {/* Основной контент */}
      <div className="home-page__content">
        {/* Левая колонка (30%) */}
        <div className="home-page__left">
          <h2>Интересная колонка</h2>
          <BannerGrid banners={banners} />
        </div>

        {/* Правая колонка (65%) */}
        <div className="home-page__right">

          <h2 className="home-page__title">Анкеты Калуга</h2>
          {sortedProducts.length === 0 ? (
            <div className="home-page__no-products">Нет доступных товаров.</div>
          ) : (
            <div className="home-page__products">
              {sortedProducts.map((product) => (
                <ProductCard key={product.id} product={product} isDashboard={false} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
